import React from 'react';
import './NewLogin.scss';
import defaultBackground from '../../../Assets/Images/LoginBackground/default.webp';
import BimeBackground from '../../../Assets/Images/LoginBackground/BimeBackground.webp';

const LoginBackground = ({initialData}) => {
  return (
    <>
      {initialData?.type === "defualt" &&
        <img className={"LoginBackground"} src={defaultBackground} alt={"LoginBackground"}/>}
      {initialData?.type === "bime" &&
        <img className={"LoginBackground"} src={BimeBackground} alt={"LoginBackground"}/>}
      {initialData?.type === "arka" &&
        <img className={"LoginBackground"} src={defaultBackground} alt={"LoginBackground"}/>}
    </>
  );
};

export default LoginBackground;